import { ExecutionPath } from '../../models/execution-path';
import { initialState } from '../state';
import {
  ExecutedPathActions,
  ExecutedPathActionTypes,
  UserClicksElementsActions, UserClicksElementsActionTypes
} from '../actions';

export function executionPath(state = initialState.executionPath, action: ExecutedPathActions | UserClicksElementsActions): ExecutionPath {
  switch (action.type) {
    case ExecutedPathActionTypes.CLEAR_ITEMS_TO_SELECT: {
      return {
        ...state,
        currentUserTaskHolder: null,
        connectionsToActivitiesForSelectionIds: [],
        nodesForSelection: []
      };
    }
    case ExecutedPathActionTypes.CLEAR_EXECUTION_HISTORY: {
      return null;
    }
    case ExecutedPathActionTypes.UPDATE_EXECUTION_PATH: {
      return action.payload.executionPath;
    }
    case UserClicksElementsActionTypes.SET_ANSWER: {
      return {
        ...state,
        executedNodes: [...state.executedNodes, { ...state.currentUserTaskHolder, selectedAnswerNodeId: action.payload.selectedActivityId}],
        currentUserTaskHolder: null
      };
    }
    default: {
      return state;
    }
  }
}

